import * as React from 'react';
import Typography from '@material-ui/core/Typography';

interface Props {
  children: React.ReactNode;
}

const TabContainer: React.SFC<Props> = props => {
  return (
    <Typography component="div" style={{ padding: 8 * 3 }}>
      {props.children}
    </Typography>
  );
};

export default TabContainer;
